import { Flex } from '@chakra-ui/react'

import MedicalRecordManagementContextProvider from './contexts/MedicalRecordManagementContext'
import MedicalRecordManagementFilter from './views/MedicalRecordManagementFilter'
import MedicalRecordManagementStatus from './views/MedicalRecordManagementStatus'
import MedicalRecordManagementTable from './views/MedicalRecordManagementTable'

export function MedicalRecordManagement() {
  return (
    <MedicalRecordManagementContextProvider>
      <Flex
        w={'full'}
        h={'full'}
        flexDirection={'column'}
        gap={6}
        px={6}
        pt={6}
      >
        <MedicalRecordManagementStatus />
        <MedicalRecordManagementFilter />
        <MedicalRecordManagementTable />
      </Flex>
    </MedicalRecordManagementContextProvider>
  )
}
